<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando"></transition>

    <div class="wrapper" v-else-if="formulario">
      <div class="topo-header centro">
        <botao-voltar nomeRota="Formularios" />
        <h1>{{ formulario.titulo }}</h1>        
      </div>
      <div>
        <p class="topo-header centro">
            Considere o período de
            <span class="spc"><strong>{{ formatarData(formulario.data_periodo_inicio) }}</strong></span>
            <span class="spc">a</span>
            <span class="spc"><strong>{{ formatarData(formulario.data_periodo_final) }}</strong></span> ao responder este formulário.
        </p>
      </div>
      <div class="form centro">
        <MsgErroFormularios
          ref="msgErro"
          v-if="erroApi"
          :mensagens="{ api: erroApi }"
          :erro="!!erroApi"
          @fechar-erro="erroApi = null"
        />

      <SelecionarServidor
        :formulario-id="id"
        :servidores-ja-designados="respondentes"
        :servidor-em-edicao="servidorAvaliado"
        :usuario-logado="usuarioLogado"
        @servidores-selecionados="onServidoresSelecionados"
        @designacao-sucesso="recarregarRespondentes" />
        <form @submit.prevent="submeterRespostas">      
          <div class="caixa-form">
            <div
              v-for="(pergunta_formulario, index) in formulario.perguntas_formulario"
              :key="pergunta_formulario.id"
              class="pergunta-container"
            >
              <p class="pergunta-texto">
                <b>{{ index + 1 }}. {{ pergunta_formulario.pergunta.texto }}</b>
              </p>

              <div v-if="pergunta_formulario.tipo_pergunta === 'discursiva'">
                <textarea
                  rows="3"
                  placeholder="Digite sua resposta aqui..."
                  v-model="respostas[index].texto"
                ></textarea>
              </div>

              <div v-if="pergunta_formulario.tipo_pergunta === 'escolha_unica'" class="radioContainer">
                <div
                  v-for="alternativa in pergunta_formulario.alternativas"
                  :key="alternativa.id"
                  class="radioOption"
                >
                  <input
                    type="radio"
                    :id="`pf-${pergunta_formulario.id}-alt-${alternativa.id}`"
                    :name="'pergunta_' + pergunta_formulario.id"
                    :value="alternativa.resposta.id"
                    :checked="respostas[index].resposta_id === alternativa.resposta.id"
                    @change="respostas[index].resposta_id = alternativa.resposta.id"
                  />
                  <label :for="`pf-${pergunta_formulario.id}-alt-${alternativa.id}`">
                    {{ alternativa.resposta.texto }}
                  </label>
                </div>
              </div>

              <div v-if="pergunta_formulario.tipo_pergunta === 'multipla_escolha'" class="checkboxContainer">
                <div
                  v-for="alternativa in pergunta_formulario.alternativas"
                  :key="alternativa.id"
                  class="checkboxOption"
                >
                  <input
                    type="checkbox"
                    :id="`pf-${pergunta_formulario.id}-alt-${alternativa.id}`"
                    :value="alternativa.resposta.id"
                    :checked="respostas[index].resposta_id.includes(alternativa.resposta.id)"
                    @change="toggleCheckbox(index, alternativa.resposta.id, $event.target.checked)"
                  />
                  <label :for="`pf-${pergunta_formulario.id}-alt-${alternativa.id}`">
                    {{ alternativa.resposta.texto }}
                  </label>
                </div>
              </div>
            </div>
            <div class="pergunta-container">
              <p class="pergunta-texto">
                <b>{{ formulario.perguntas_formulario.length + 1 }}. Observações</b> (opcional)
              </p>

              <textarea
                rows="4"
                placeholder="Digite algumas observações sobre este servidor."
                v-model="observacoes"
              ></textarea>
            </div>
            <div class="bt-salvar">
              <button type="submit" :disabled="!servidorAvaliado || semLotacaoAtual">Submeter Respostas</button>
            </div>            
          </div>
        </form>
        <br>
          <ListaRespondentes 
          v-if="respondentes.length > 0 && usuarioLogado " 
          :respondentes="respondentes" 
          :formulario-id="id"
        />
      </div>
    </div>

    <div v-if="showSuccessPopup" class="success-popup-overlay">
      <div class="success-popup">
        <p>{{ successMessage }}</p>
        <button @click="closeSuccessPopup">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import FormularioApi from "../../services/FormularioApi";
import BotaoVoltar from "../../components/BotaoVoltar.vue";
import SelecionarServidor from "../../components/formularios/SelecionarServidor.vue";
import ListaRespondentes from "../../components/formularios/ListaRespondentes.vue";
import MsgErroFormularios from "../../components/MsgErroFormularios.vue";
import HomeApi from "../../services/HomeApi";
import { parseISO, format } from "date-fns";

export default {
  name: "ResponderFormulario",
  metaInfo() {
    return {
      title: "Responder Formulário", 
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
    };
  },
  props: {
    id: { type: [String, Number], required: true },
  },
  components: { BotaoVoltar, SelecionarServidor, ListaRespondentes, MsgErroFormularios },
  data() {
    return {
      carregando: true,
      formulario: null,
      respostas: [],
      servidorAvaliado: null,
      respondentes: [], // <-- Guarda a lista de quem já respondeu
      erroApi: null,
      modoEdicao: false,
      usuarioLogado: null,
      showSuccessPopup: false,
      successMessage: '',
      OBSERVACOES_ID: 1,
      observacoes: "",
    };
  },
  created() {
    this.formularioApi = new FormularioApi();
    this.homeApi = new HomeApi();
    this.carregarDadosDaPagina();
  },

  computed: {
    // Sem lotação atual o usuário não pode ser registrado como avaliador.
    semLotacaoAtual() {
      return !!this.usuarioLogado && !this.usuarioLogado.lotacao_id;
    },
  },
  methods: {
    // Função para carregar tudo que a página precisa em paralelo
    async recarregarRespondentes() {
      try {
        this.respondentes = await this.formularioApi.getRespondentes(this.id);
      } catch (error) {
        this.erroApi = "Não foi possível atualizar a lista de servidores designados.";
      }
    },
    formatarData: function (value) {
      if (!value) return '';
      try {
        return format(parseISO(value), "dd/MM/yyyy");
      } catch (error) {
        console.error("Erro ao formatar data:", value, error);
        return "Data inválida";
      }
    },
    async carregarDadosDaPagina() {
      this.carregando = true;
      try {
        const avaliadoIdParaEditar = this.$route.query.avaliado_id;
        this.modoEdicao = !!avaliadoIdParaEditar;

        const [dadosFormulario, dadosRespondentes, dadosUsuarioLogado] = await Promise.all([
          this.formularioApi.getFormulario(this.id),
          this.formularioApi.getRespondentes(this.id),
          this.homeApi.getUsuarioAtual()
        ]);
       
        this.formulario = dadosFormulario;
        this.respondentes = dadosRespondentes;
        this.usuarioLogado = dadosUsuarioLogado;
        if (this.semLotacaoAtual) {
          this.erroApi = "Você não possui lotação atual cadastrada no Sistema de Avaliação, por isso não pode "
            + "responder avaliações. Procure o administrador do sistema.";
        }


        // Se estiver em modo de edição, busca as respostas salvas. A API recusa
        // quando o usuário não avaliou o servidor ou o formulário não está
        // aberto; nesse caso mostra o motivo e segue como nova avaliação.
        let dadosSalvos = null;
        if (this.modoEdicao) {
          try {
            dadosSalvos = await this.formularioApi.getRespostasParaEdicao(this.id, avaliadoIdParaEditar);
          } catch (err) {
            this.erroApi = err.response?.data?.error || "Não foi possível carregar as respostas para edição.";
            this.modoEdicao = false;
          }
        }

        if (this.modoEdicao) {
          // O `servidorAvaliado` é o próprio usuário em edição
          const servidorParaEditar = this.respondentes.find(r => r.id === parseInt(avaliadoIdParaEditar));
          this.servidorAvaliado = {
            ...(servidorParaEditar || { id: parseInt(avaliadoIdParaEditar) }),
            lotacao_id: dadosSalvos.lotacao_id,
          };
          
          // Preenche o array `respostas` com os dados da API
          this.respostas = this.formulario.perguntas_formulario.map(pf => {
          
          const respostaObs = (dadosSalvos.respostas || []).find(rs => rs.pergunta_id === this.OBSERVACOES_ID);
          this.observacoes = respostaObs ? respostaObs.texto || "" : "";
          // --- INÍCIO DA CORREÇÃO ---
          
          // 1. Usamos .filter() para pegar TODAS as respostas salvas para esta pergunta
          const respostasSalvas = dadosSalvos.respostas.filter(rs => rs.pergunta_id === pf.pergunta_id);

          let respostaIdParaBind;
          let textoParaBind = "";

          if (pf.tipo_pergunta === 'multipla_escolha') {
            // 2. Se for múltipla escolha, criamos um array com os IDs de todas as respostas
            respostaIdParaBind = respostasSalvas.map(rs => rs.resposta_id);
          
          } else {
            // 3. Se for escolha única ou discursiva, só pode haver uma resposta.
            // Pegamos a primeira (e única) do array filtrado.
            const respostaUnica = respostasSalvas[0];
            
            respostaIdParaBind = respostaUnica?.resposta_id || null;
            textoParaBind = respostaUnica?.texto || "";
          }

          // 4. Retornamos a estrutura correta
          return {
            pergunta_id: pf.pergunta_id,
            tipo_pergunta: pf.tipo_pergunta,
            resposta_id: respostaIdParaBind, // Agora é um array [7, 9] para múltipla escolha, ou um ID 9 para única
            texto: textoParaBind,           // Agora é "meu texto" para discursiva
            avaliador_id: this.usuarioLogado.id,
            avaliado_id: parseInt(avaliadoIdParaEditar),
            };
          });
        } else {
          this.respostas = this.formulario.perguntas_formulario.map((pf) => ({
            pergunta_id: pf.pergunta_id,
            tipo_pergunta: pf.tipo_pergunta,
            resposta_id: pf.tipo_pergunta === "multipla_escolha" ? [] : null,
            texto: "",
            avaliador_id: this.usuarioLogado.id,
            avaliado_id: null,
          }));
        }

      } catch (err) {
        console.error("Erro ao carregar dados da página:", err);
        this.erroApi = err.response?.data?.error || "Falha ao carregar os dados do formulário.";
      } finally {
        this.carregando = false;
      }
    },

    onServidoresSelecionados(servidores) {
      
      if (servidores && servidores.length > 0) {
        const servidor = servidores[0];
        this.servidorAvaliado = servidor;
        
        // ✅ AGORA USA O lotacao_id REAL DA API
        const avaliadoId = servidor.lotacao_id;
        
        this.respostas.forEach(r => {
          r.avaliado_id = avaliadoId;
        });
      }
    },

    toggleCheckbox(perguntaIndex, respostaId, checked) {
      const arr = this.respostas[perguntaIndex].resposta_id;
      if (checked) {
        if (!arr.includes(respostaId)) arr.push(respostaId);
      } else {
        const idx = arr.indexOf(respostaId);
        if (idx > -1) arr.splice(idx, 1);
      }
    },

    resetForm() {
      this.servidorAvaliado = null;
      this.respostas = this.formulario.perguntas_formulario.map((pf) => ({
        pergunta_id: pf.pergunta_id,
        tipo_pergunta: pf.tipo_pergunta,
        resposta_id: pf.tipo_pergunta === "multipla_escolha" ? [] : null,
        texto: "",
        avaliador_id: this.usuarioLogado.id,
        avaliado_id: null,
      }));
      this.observacoes = "";
    },

    closeSuccessPopup() {
      this.showSuccessPopup = false;
      this.successMessage = '';
      this.resetForm();
      if (this.modoEdicao) {
        this.$router.push({ query: {} });
      }
    },

    async submeterRespostas() {
      
      if (!this.servidorAvaliado || !this.servidorAvaliado.lotacao_id) {
        alert("Por favor, selecione um servidor para avaliar.");
        return;
      }

      try {
        this.erroApi = null;

        const respostasParaEnviar = this.respostas.map(r => ({
          ...r,
          avaliador_id: this.usuarioLogado.lotacao_id,
          avaliado_id: this.servidorAvaliado.lotacao_id,
        }));
        respostasParaEnviar.push({
          pergunta_id: this.OBSERVACOES_ID,
          tipo_pergunta: "discursiva",
          texto: this.observacoes || "",
          avaliador_id: this.usuarioLogado.lotacao_id,
          avaliado_id: this.servidorAvaliado.lotacao_id,
        });
        if (this.modoEdicao) {
          await this.formularioApi.atualizarRespostas(
            this.id, 
            this.servidorAvaliado.lotacao_id, 
            respostasParaEnviar
          );
          this.successMessage = "Respostas atualizadas com sucesso!";
        } else {
          await this.formularioApi.salvarRespostas(this.id, respostasParaEnviar);
          this.successMessage = "Respostas enviadas com sucesso!";
        }
        
        this.showSuccessPopup = true;
        await this.recarregarRespondentes();

      } catch (err) {
        console.error("ERRO:", err);
        this.erroApi = err.response?.data?.error || "Erro ao enviar respostas.";
        // A mensagem fica no topo do formulário, longe do botão de envio.
        this.$nextTick(() => {
          const el = this.$refs.msgErro?.$el;
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    },
  },
  watch: {
    // Observa o objeto $route
    '$route'(to, from) {
      // Verifica se a rota mudou (ex: query params)
      if (to.fullPath !== from.fullPath) {
        // Se mudou, força a recarga dos dados
        this.carregarDadosDaPagina();
      }
    }
  },
};
</script>

<style scoped lang="scss">
.periodo-msg {
  width: 100%;
  margin-top: 4px;
  font-size: 14px;
  color: #555;
}
.spc {
  margin: 0 4px;
}

.wrapper {
  padding: 1.5rem;
}
.caixa-form {
  background-color: #f0f0f0;
  padding: 1.5rem;
  border-radius: 8px;
}
.pergunta-container {
  background-color: #fff;
  padding: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}
.pergunta-texto {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;
  font-size: 1rem;
}
.radioContainer,
.checkboxContainer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.radioOption,
.checkboxOption {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.radioOption label,
.checkboxOption label {
  font-weight: normal;
  cursor: pointer;
}
.bt-salvar button {
  padding: 0.75rem 1.5rem;
  background-color: #005516;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  width: 100%;
}

.success-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.success-popup {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.success-popup p {
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.success-popup button {
  padding: 0.75rem 1.5rem;
  background-color: #005516;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}
</style>